import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BoardConst from '../../utils/constants/board';
import AICard from '../cards/ai.card';
import PeopleCard from '../cards/people.card';
import FreeTextCard from '../cards/text.card';
import WsCard from '../cards/ws.card';

const CardList = ({
    boardView,
    boardType,
    columnId,
    memberHighlightedId,
    viewAiPane,
    highlightedAI,
    user,
    data=[],
    cardType,
    userPermission,
    boardDetails,
    fusDetail,
    showIssueTypeIcon,
    highlightIssuesByType,
} : any) => {
    const { t } = useTranslation();
    const [limit, setLimit] = useState(100);

    const handleLoadMore = () => {
        setLimit(limit + 100);
    };

    const getCard = (card: any, index: number) => {
        let CardComp = null;
        if (boardView == BoardConst.BOARD_VIEW_ACTIVITY) {
            CardComp = <AICard
                key={`${columnId}_${card.id}`}
                columnId={columnId}
                card={card}
                index={index}
                memberHighlightedId={memberHighlightedId}
                highlightedAI={highlightedAI}
                showIssueTypeIcon={showIssueTypeIcon}
                highlightIssuesByType={highlightIssuesByType}
                isActive={(viewAiPane && viewAiPane.id == card.id)}
                user={user}
                wsPermissions={boardDetails.wsPermissions}
            />;
        }
        else {
            if (cardType == BoardConst.BOARD_DATATYPE_PEOPLE) {
                CardComp = <PeopleCard
                                key={`${columnId}_${card.id}_${index}`}
                                columnId={columnId}
                                card={card}
                                index={index}
                                user={user}
                                userPermission={userPermission}
                                boardInfo={boardDetails}
                            />;
            }
            else if (cardType == BoardConst.BOARD_DATATYPE_WORKSTREAMS) {
                CardComp = <WsCard
                                key={`${columnId}_${card.id}_${index}`}
                                columnId={columnId}
                                card={card}
                                index={index}
                                user={user}
                                userPermission={userPermission}
                                boardInfo={boardDetails.board}
                            />;
            }
            else if (cardType == BoardConst.BOARD_DATATYPE_FREETEXT) {
                CardComp = <FreeTextCard
                                key={`${columnId}_${card.id}`}
                                columnId={columnId} {...card}
                                index={index}
                                user={user}
                                boardDetails={boardDetails}
                                fusDetail={fusDetail}
                            />;
            }
        }
        if (CardComp == null) {
            return CardComp;
        }
        return CardComp;
    }

    const hasMoreItems = (data.length > limit);

    return (
        <>
            {data.slice(0, limit).map((card: any, index: number) => getCard(card, index))}
            {hasMoreItems && <button className="load-more-button" onClick={handleLoadMore}>{t('Load more')}</button>}
        </>
    );
}

export default CardList;
